import { Checkbox } from '@vtex/shoreline'

import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import { ProductThumb } from '../ProductThumb'
import styles from '../styles.module.css'
import { ProductCandidate } from './types'

type CandidateListItemProps = {
  row: ProductCandidate
  /** Chave do produto → marca a que já está vinculado (`null` quando está sem marca). */
  existingByKey: Record<string, string | null>
  isSelected: boolean
  toggle: (row: ProductCandidate) => void
  /** Conteúdo à direita da linha; não é chamado para produto já vinculado. */
  renderAside?: (row: ProductCandidate) => React.ReactNode
}

/** Linha do picker: produto já em "Meus produtos" vem marcado e travado. */
export const CandidateListItem: React.FC<CandidateListItemProps> = ({
  row,
  existingByKey,
  isSelected,
  toggle,
  renderAside
}) => {
  const { t } = useAPPTranslation()

  const alreadyAdded = row.key in existingByKey
  const existingBrand = existingByKey[row.key]
  const alreadyAddedKey = existingBrand
    ? 'rm:advertiserProducts.addModal.alreadyAddedInBrand'
    : 'rm:advertiserProducts.addModal.alreadyAdded'

  return (
    <li
      className={`${styles.suggestionRow} ${
        alreadyAdded
          ? styles.suggestionRowDisabled
          : styles.suggestionRowClickable
      }`}
    >
      <Checkbox
        checked={alreadyAdded || isSelected}
        disabled={alreadyAdded}
        onChange={() => toggle(row)}
        aria-label={row.name}
      />

      {/* Atalho de mouse para a linha inteira; o teclado marca pelo checkbox. */}
      <button
        type="button"
        className={styles.suggestionRowMain}
        disabled={alreadyAdded}
        tabIndex={-1}
        onClick={() => toggle(row)}
      >
        <ProductThumb url={row.imageUrl} />

        <span className={styles.productText}>
          <span className={styles.productName} title={row.name}>
            {row.name}
          </span>
          <span className={styles.productMeta}>
            {row.identifierType === 'sku'
              ? `SKU:${row.sku}`
              : `EAN:${row.gtin}`}
          </span>
        </span>
      </button>

      {(alreadyAdded || !!renderAside) && (
        <span className={styles.rowBrand}>
          {alreadyAdded ? (
            <span className={styles.alreadyAdded}>
              {t(alreadyAddedKey, { brand: existingBrand })}
            </span>
          ) : (
            renderAside?.(row)
          )}
        </span>
      )}
    </li>
  )
}
